import React from 'react';
import { useGroupsCreateFormInit } from './useGroupsCreateFormInit';
import { useGroupsCreateModel } from './useGroupsCreateModel';
import { useGroupsCreateStore } from '../pagehooks/useGroupsCreateStore';
import useNgContext from '../../../../core/services/useNgContext';
import ValidInputText from '../../../../core/components/validation/ValidInputText';
import ValidInputDroplistText from '../../../../core/components/validation/ValidInputDroplistText';
import ValidInputRadioText from '../../../../core/components/validation/ValidInputRadioText';
import Button from '../../../../core/components/Button';
import FormEdit from '../../../../core/components/form/FormEdit';
import FormFieldTitleBar from '../../../../core/components/form/FormFieldTitleBar';
import FormSubmit from '../../../../core/components/form/FormSubmit';

const FormAccountSection = (): JSX.Element => {
    useGroupsCreateFormInit();
    const { cancelEdit, state } = useGroupsCreateStore();
    const { model, setPropText, submit } = useGroupsCreateModel();
    const ctx = useNgContext();

    const showSubmit = ctx.User?.Type === 'VERITYSA';
    const disableAccountFields = ctx.User?.Type === 'VERITY';

    function handlePropChange(prop: string, val: string | number): void {
        setPropText(prop, val);
    }

    return (
        <FormEdit
            formName="grpEditAcct"
            cssName="grp-acct"
        >
            <FormFieldTitleBar title="Account" />
            <ValidInputRadioText
                prop={model.ObjectState}
                onChange={handlePropChange}
                disabled={disableAccountFields}
            />
            <ValidInputText
                prop={model.Name}
                placeholder={model.Name.lbl}
                maxlen={50}
                width={240}
                onChange={handlePropChange}
                disabled={disableAccountFields}
            />
            <ValidInputDroplistText
                prop={model.Type}
                onChange={handlePropChange}
                disabled={disableAccountFields}
            />
            {showSubmit ? (
                <FormSubmit lbl="Apply Changes">
                    <Button onClick={submit}>{state.mode}</Button>
                    <span>
                        <Button
                            cssName="btn-cancel"
                            onClick={cancelEdit}
                        >
                            CANCEL
                        </Button>
                    </span>
                </FormSubmit>
            ) : null}
        </FormEdit>
    );
};

export default FormAccountSection;
